export const GET_PHARMACY_LIST = "GET_PHARMACY_LIST"
export const CLEAR_PHARMACY_LIST ="CLEAR_PHARMACY_LIST"